<div class="d-flex justify-content-evenly" style="width: 1000px;">

    <div class="table_div_group">
        <div class="table_div_group_header">
            <label>{{'VENUE.GROUPS' | translate}}:</label>
            <i class="pi pi-plus-circle add_group_icon" (click)="openAddGroup() "></i>
        </div>
        <div class="p-1 table_group_names">
            <p-selectButton *ngIf="!showAddGroup" id="tableGroups" [options]="createOrEditCapacityModel.capacityGroups"
                [(ngModel)]="selectedGroup">
                <ng-template let-item>
                    <span style="max-width: 70px;overflow-wrap: anywhere;">{{item.name}}</span>
                    <div>
                        <i style="padding: 3px;font-size: small;" (click)="openUpdateGroup(item);"
                            class="pi pi-pencil"></i>
                        <i style="padding: 3px;font-size: small;" (click)="removeGroup(item.index);"
                            [class.delete-disabled]="isGroupDeleteDisabled(item.index)" class="pi pi-trash"></i>
                    </div>
                </ng-template>
            </p-selectButton>
            <div *ngIf="showAddGroup">
                <label class="mt-1  w-100 btn_add_tb_group_lbl">{{'VENUE.GROUP_NAME'|translate}}:</label>
                <input type="text" class="mt-1 mb-2 w-100 btn_add_tb_group" [(ngModel)]="addTableGroup.name">
              <div class="capacity_divisions_dropdown">
                <p-multiSelect [options]="listDivisions" [(ngModel)]="addTableGroup.subvenueIds"
                               defaultLabel="{{'DIVISION.DIVISIONS' | translate}}" optionLabel="name"
                               optionValue="id" [showHeader]="false" [appendTo]="'body'" [panelStyleClass]="'capacity_divisions_multiselect_dropdown'">
                </p-multiSelect>
              </div>
                <button *ngIf="!showUpdateGroup" class="w-50 mb-2 table_btn" (click)="addGroup();"> <i
                        class="pi pi-check-circle"></i></button>
                <button *ngIf="showUpdateGroup" class="w-50 mb-2 table_btn" (click)="updateGroup(addTableGroup);"> <i
                        class="pi pi-check-circle"></i></button>
                <button class="w-50 mb-2 table_btn" (click)="closeAddGroup();"><i
                        class="pi pi-times-circle"></i></button>
            </div>
        </div>

    </div>
    <div pDroppable="table" (onDrop)="drop($event)" class="table_div_drop hide_mobile">
        <img *ngFor="let table of selectedGroup.capacityTables" pDraggable="table" (onDragStart)="dragStart($event,table)"
             [src]="table.shape" (onDragEnd)="dragEnd($event)" class="table_img" style="position: fixed;"
             [style.top]="table.yPosition" [style.left]="table.xPosition" (dblclick)="onDoubleClick($event , table)">
        <p-confirmPopup class="delete-capacity-table-popup"></p-confirmPopup>
    </div>
    <div id="page-0" class="document-page table_div_drop dropZone show_mobile" #dropZone cdkDropList id="drop-list"
    cdkDropListSortingDisabled="true" (cdkDropListDropped)="itemDropped($event)">
    <div *ngFor="let field of selectedGroup.capacityTables" cdkDrag [cdkDragData]="field"
        (cdkDragDropped)="changePosition($event,field)" class="drop-item" [style.top]="field.yPosition"
        [style.left]="field.xPosition">
        <img class="table_img"  [src]="field.shape">
        <div *cdkDragPlaceholder class="field-placeholder" style="display: none;"></div>
    </div>

</div>

</div>
<div class="d-flex mt-3 ms-3 capacity-info">
    <span>{{'VENUE.CAPACITY_MESSAGE' | translate}}</span>
</div>
<div class="d-flex justify-content-evenly m-3">
    <div class="d-flex justify-content-evenly me-2 table_group">
        <img class="table_img hide_mobile" *ngFor="let table of tablePicture" [src]="table.shape" pDraggable="table"
             (onDragStart)="dragStart($event,table)" (onDragEnd)="dragEnd($event)">
        <div class="sidenav-inner show_mobile" cdkDropList cdkDropListConnectedTo="drop-list">
            <span id="div1" cdkDrag *ngFor="let table of tablePicture" [cdkDragData]="table" (cdkDragMoved)="moved($event)">
                <img class="table_img"  [src]="table.shape">
                <span *cdkDragPlaceholder class="field-placeholder" style="display: none;"></span>
            </span>
        </div>
    </div>
    <div class="table_btn_group">
        <button *ngIf="!enableEdit" class="w-100 mb-2 table_btn" (click)="save(createOrEditCapacityModel)">{{'SAVE' | translate}}</button>
        <button *ngIf="enableEdit" class="w-100 mb-2 table_btn"
            (click)="updateOrDeleteCapacity(createOrEditCapacityModel)">{{'UPDATE' | translate}}</button>
        <button class="w-100 table_btn" (click)="cancel()">{{'CANCEL' | translate}}</button>
    </div>
</div>
